import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import animator from '../../helpers/animator';
import UserAvatarWithInfo from '../../components/UserAvatar/UserAvatarWithInfo';
import './TaskCardInner.scss';

function formatDate(date) {
  let formattedDate = null;
  if (date) {
    let dateFormatter = new Date(date);
    let month = dateFormatter.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    let day = dateFormatter.getDate();
    if (day < 10) {
      day = '0' + day;
    }
    let year = dateFormatter.getFullYear();
    formattedDate = month + '/' + day + '/' + year;
  }
  return formattedDate;
}

export default class TaskCardInner extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
      selectedUser: null,
      displayUserInfoPopup: false,
      popupPositionFixedFrom: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.task) {
      this.setState({ task: this.props.task });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.task != prevProps.task) {
      this.setState({ task: this.props.task });
    }
    if (!this.props.quickAssignments && this.state.selected) {
      this.setState({ selected: false });
    }
  }

  handleInfoClick(elementReference, assignmentType, multiAssignedUsers) {
    const elementRect = this[elementReference].getBoundingClientRect();
    let top = elementRect.top + 22;
    let left = multiAssignedUsers ? elementRect.left + 32 : elementRect.left - 97;

    this.setState({
      multiAssignedUsers,
      popupTopPosition: top,
      popupLeftPosition: left,
      displayUserInfoPopup: assignmentType,
    });
  }

  handleInfoClose() {
    this.setState({
      displayUserInfoPopup: false,
      popupTopPosition: null,
      popupLeftPosition: null,
      multiAssignedUsers: null,
    });
  }

  createMemberArray() {
    if (this.state.task) {
      if (this.state.task.user_task_assignments && this.state.task.user_task_assignments.length > 0) {
        let fieldUsers = [];
        let reviewerUsers = [];
        let approverUsers = [];
        let assignedUser = this.state.task.user_task_assignments.filter(user_task_assignment => {
          if (user_task_assignment) {
            switch (user_task_assignment.assignment_type) {
            case 'field_user':
              fieldUsers.push(user_task_assignment);
              if (fieldUsers.length > 1) {
                return false;
              }
              return true;
            case 'reviewer':
              reviewerUsers.push(user_task_assignment);
              if (reviewerUsers.length > 1) {
                return false;
              }
              return true;
            case 'approver':
              approverUsers.push(user_task_assignment);
              if (approverUsers.length > 1) {
                return false;
              }
              return true;
            default:
              return false;
            }
          }
          else {
            return false;
          }
        });
        assignedUser = assignedUser.map(user_task_assignment => {
          if (user_task_assignment) {
            switch (user_task_assignment.assignment_type) {
            case 'field_user':
              user_task_assignment.captionText = 'Assigned to';
              user_task_assignment.sortOrder = 1;
              return user_task_assignment;
            case 'reviewer':
              user_task_assignment.captionText = 'Reviewer';
              user_task_assignment.sortOrder = 2;
              return user_task_assignment;
            case 'approver':
              user_task_assignment.captionText = 'Approver';
              user_task_assignment.sortOrder = 3;
              return user_task_assignment;
            default:
              break;
            }
          }
          return null;
        });

        assignedUser.sort((u1, u2) => {
          if (u1.sortOrder < u2.sortOrder) {
            return -1;
          }
          else if (u1.sortOrder > u2.sortOrder) {
            return 1;
          }
          else {
            return 0;
          }
        });
        const count = assignedUser.length;
        return assignedUser.map((user_task, index) => {
          if (user_task) {
            let hasBorder = index < count - 1;
            let multiAssigned = false;
            let user, users;
            if (user_task.assignment_type == 'field_user' && fieldUsers.length > 1) {
              multiAssigned = true;
              users = fieldUsers.map(uta => uta.user);
            }
            else if (user_task.assignment_type == 'reviewer' && reviewerUsers.length > 1) {
              multiAssigned = true;
              users = reviewerUsers.map(uta => uta.user);
            }
            else if (user_task.assignment_type == 'approver' && approverUsers.length > 1) {
              multiAssigned = true;
              users = approverUsers.map(uta => uta.user);
            }
            else {
              user = user_task.user;
            }

            const elementReference = `avatarHover${user_task.id}${user_task.user_id}`;

            return (
              <div
                className={'assigned-user' + (hasBorder ? ' has-border' : '')}
                key={'user-task-card-' + this.props.filter + '-' + user_task.id}
                ref={element => { this[elementReference] = element; }}
              >
                <UserAvatarWithInfo
                  id={'user-avatar-task-card-' + (user_task.user ? user_task.user.id : user_task.user_id + user_task.id)}
                  key={'user-avatar-task-card-' + (user_task.user ? user_task.user.id : user_task.user_id + user_task.id)}
                  user={user}
                  displayed={this.state.displayUserInfoPopup}
                  assignment={user_task.assignment_type}
                  popupTopPosition={this.state.popupTopPosition}
                  popupLeftPosition={this.state.popupLeftPosition}
                  multiAssigned={multiAssigned}
                  multiAssignedUsers={this.state.multiAssignedUsers}
                  handleInfoOpen={() => this.handleInfoClick(elementReference, user_task.assignment_type, users)}
                  handleSelected={() => this.handleInfoClick(elementReference, user_task.assignment_type, users)}
                  handleInfoClose={this.handleInfoClose}
                />
                <div className="user-text">{user_task.captionText}</div>
              </div>
            );
          }
          else {
            return null;
          }
        });
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }

  render() {
    if (!this.state.task) {
      return null;
    }
    let notificationCount = 0;
    let notifications = null;
    if (this.props.notifications) {
      const notifications = this.props.notifications.filter((notification) => {
        return ((notification.notifiable && notification.notifiable.completion_criteria && notification.notifiable.id == this.state.task.id) ||
          (notification.notifiable_type == 'Task' && notification.notifiable_id == this.state.task.id));
      }).map((notification, index) => {
        return notification;
      });
      notificationCount = notifications.length;
    }
    if (notificationCount) {
      notifications = <div className="notification-info">
        <div className="notification-icon">
        </div>
        <div className="notification-count">{notificationCount}</div>
      </div>;

    }

    let completed = 0;
    let total = 0;
    let attachmentCount = this.state.task.task_attachments_count;
    if (this.state.task.completion_criteria_counts) {
      total = this.state.task.completion_criteria_counts.total;
      completed = this.state.task.completion_criteria_counts.completed;
    }

    const assignedUser = this.createMemberArray();
    let stepsRejected = 0;
    if (this.state.task.completion_criteria_counts) {
      stepsRejected = this.state.task.completion_criteria_counts.rejected;
    }

    let rejected = null;
    if (stepsRejected > 0) {
      rejected = <div className="rejected-task">Rejected</div>;
    }

    const { task } = this.state;

    let taskDate = null;
    if (task.estimated_completion_date || task.actual_completion_date) {
      let calendarIcon = null;
      let taskCompletion = null;
      let estimatedCompletionDate = formatDate(task.actual_completion_date ? task.actual_completion_date : task.estimated_completion_date);
      const overdue = !task.actual_completion_date && new Date(estimatedCompletionDate) < new Date() ? ' overdue' : '';
      const completed = task.status == 'not_started' || task.status == 'in_progress' ? '' : ' completed';
      calendarIcon = <div className={'calendar-icon' + overdue + completed} />;

      taskCompletion = <div className={'icon-text' + overdue}>{estimatedCompletionDate}</div>;

      const whichDatePopup = <div className="which-date-popup">{task.actual_completion_date ? 'Actual Completion Date' : 'Projected Completion Date'}</div>;

      taskDate = <div className='completion-date'>
        {calendarIcon}
        {taskCompletion}
        {whichDatePopup}
      </div>;
    }

    return (
      <div className="task-inner-card" data-qa="task-inner-card">
        <div className="name-line">
          <div
            className={'name' + (this.state.task.name.length > 14 ? ' name--long' : '')}
            ref={(el) => { this.taskNameContainer = el; }}
          >
            {this.state.task.name}
          </div>
          {notifications}
        </div>
        {this.props.task.project && this.props.task.project.name &&
          <div className="project-line">
            <div
              className={'project-name' + (this.props.task.project.name.length > 26 ? ' project-name--long' : '')}
              ref={(el) => { this.projectNameContainer = el; }}
            >
              {this.props.task.project.name}
            </div>
          </div>
        }
        <div className="info-icon-row">
          <div className="attachments">
            <div className="attachment-icon" />
            <div className="icon-text">{attachmentCount}</div>
          </div>
          <div className="completion-criteria">
            <div className="completion-icon" />
            <div className="icon-text">{completed + ' | ' + total}
            </div>
          </div>
          {taskDate}
          {rejected}
        </div>
        <hr className="dividing-line" />
        <div className="user-list" >
          {assignedUser}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TaskCardInner/index.js